/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(initialState: { currentUser?: API.CurrentUser } | undefined) {
    const { currentUser } = initialState ?? {};
    return {
        canAccountPage:
            currentUser?.permissions?.includes('all') ||
            currentUser?.permissions?.includes('account'),
        canAwardPage:
            currentUser?.permissions?.includes('all') ||
            currentUser?.permissions?.includes('award'),
        canJudgePage:
            currentUser?.permissions?.includes('all') ||
            currentUser?.permissions?.includes('judge'),
        canContentPage:
            currentUser?.permissions?.includes('all') ||
            currentUser?.permissions?.includes('content'),
    };
}
